(function () {
  var start = Date.parse('2026-10-13T00:00:00+02:00');
  var end = Date.parse('2026-10-20T00:00:00+02:00');
  if (Date.now() < start || Date.now() >= end || (window.Shopify && window.Shopify.designMode)) return;

  var path = window.location.pathname || '/';
  if (/^\/(cart|checkout)(\/|$)/i.test(path) ||
      /^\/collections\/tydzien-cen-specjalnych(?:\/|$)/i.test(path)) return;

  var key = 'allbag-p1-popup-dismissed-until';
  try { if (Number(localStorage.getItem(key)) > Date.now()) return; } catch (_) {}

  function show() {
    if (Date.now() >= end) return;
    if (document.visibilityState !== 'visible') {
      document.addEventListener('visibilitychange', function onVisible() {
        if (document.visibilityState === 'visible') {
          document.removeEventListener('visibilitychange', onVisible);
          show();
        }
      });
      return;
    }
    if (!document.body || document.getElementById('ab-p1-popup')) return;

    var style = document.createElement('style');
    style.textContent = [
      '#ab-p1-popup{position:fixed;inset:0;z-index:2147483000;display:grid;place-items:center;padding:20px;background:rgba(0,0,0,.48);font-family:inherit;animation:abp1-fade .2s ease-out}',
      '#ab-p1-popup *{box-sizing:border-box}',
      '#ab-p1-popup .abp1-card{position:relative;width:min(100%,500px);padding:34px 30px 28px;border-radius:18px;background:#fff;color:#18311d;text-align:center;box-shadow:0 18px 60px rgba(0,0,0,.24);animation:abp1-rise .24s ease-out}',
      '#ab-p1-popup .abp1-close{position:absolute;top:10px;right:10px;width:44px;height:44px;border:0;border-radius:50%;background:#f1f4f1;color:#18311d;font-size:27px;line-height:1;cursor:pointer}',
      '#ab-p1-popup .abp1-eyebrow{display:inline-block;margin:0 42px 12px;padding:7px 12px;border-radius:99px;background:#e8f3e9;color:#003e09;font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase}',
      '#ab-p1-popup h2{margin:0 32px 10px;color:#003e09;font-size:clamp(25px,6vw,34px);line-height:1.12}',
      '#ab-p1-popup .abp1-copy{margin:0 auto 18px;max-width:390px;font-size:16px;line-height:1.5}',
      '#ab-p1-popup .abp1-price{margin:0 auto 20px;padding:16px;border-radius:14px;background:#003e09;color:#fff}',
      '#ab-p1-popup .abp1-price strong{display:block;font-size:28px;line-height:1.2}',
      '#ab-p1-popup .abp1-price span{display:block;margin-top:5px;font-size:14px;opacity:.92}',
      '#ab-p1-popup .abp1-cta{display:flex;min-height:50px;align-items:center;justify-content:center;padding:12px 20px;border-radius:12px;background:#003e09;color:#fff;text-decoration:none;font-weight:700;font-size:16px}',
      '#ab-p1-popup .abp1-cta:hover{background:#108474}',
      '#ab-p1-popup .abp1-note{margin:12px 0 0;color:#5f6d62;font-size:12px;line-height:1.45}',
      '@keyframes abp1-fade{from{opacity:0}to{opacity:1}}',
      '@keyframes abp1-rise{from{transform:translateY(10px);opacity:.8}to{transform:translateY(0);opacity:1}}',
      '@media(max-width:600px){#ab-p1-popup{align-items:end;padding:10px}#ab-p1-popup .abp1-card{max-height:85vh;overflow:auto;padding:30px 20px 22px;border-radius:18px 18px 12px 12px}#ab-p1-popup .abp1-copy{font-size:15px}}',
      '@media(prefers-reduced-motion:reduce){#ab-p1-popup,#ab-p1-popup .abp1-card{animation:none}}'
    ].join('');
    document.head.appendChild(style);

    var oldOverflow = document.body.style.overflow;
    var previousFocus = document.activeElement;
    var root = document.createElement('div');
    root.id = 'ab-p1-popup';
    root.setAttribute('role', 'presentation');
    root.innerHTML = '<section class="abp1-card" role="dialog" aria-modal="true" aria-labelledby="abp1-title" aria-describedby="abp1-copy">' +
      '<button class="abp1-close" type="button" aria-label="Zamknij okno">×</button>' +
      '<p class="abp1-eyebrow">Tylko do 19 października</p>' +
      '<h2 id="abp1-title">Tydzień cen specjalnych</h2>' +
      '<p class="abp1-copy" id="abp1-copy">7 popularnych toreb papierowych w cenach dla stałych klientów hurtowych. Rabaty ilościowe nadal się naliczają.</p>' +
      '<div class="abp1-price"><strong>od 0,45 zł brutto</strong><span>Torba 24 × 10 × 32 cm już za 0,50 zł</span></div>' +
      '<a class="abp1-cta" href="/collections/tydzien-cen-specjalnych">Zobacz wszystkie ceny</a>' +
      '<p class="abp1-note">Promocja do 19.10.2026, 23:59. Cena brutto za sztukę.</p></section>';
    var closeButton = root.querySelector('.abp1-close');
    var card = root.querySelector('.abp1-card');
    function dismiss() {
      try { localStorage.setItem(key, String(end)); } catch (_) {}
      root.remove();
      style.remove();
      document.body.style.overflow = oldOverflow;
      document.removeEventListener('keydown', onKeydown);
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    }
    function onKeydown(e) {
      if (e.key === 'Escape') { dismiss(); return; }
      if (e.key !== 'Tab') return;
      var focusable = card.querySelectorAll('a[href],button:not([disabled])');
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    closeButton.addEventListener('click', dismiss);
    root.addEventListener('click', function (e) { if (e.target === root) dismiss(); });
    root.querySelector('.abp1-cta').addEventListener('click', function () {
      try { localStorage.setItem(key, String(end)); } catch (_) {}
    });
    document.addEventListener('keydown', onKeydown);
    document.body.appendChild(root);
    document.body.style.overflow = 'hidden';
    closeButton.focus();
  }
  window.setTimeout(show, 30000);
})();